var map = {
	"./box.svg": 2030,
	"./clock.svg": 2031,
	"./close.svg": 660,
	"./geolocation.svg": 2032,
	"./size.svg": 2033,
	"./tools.svg": 2034
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;



//////////////////
// WEBPACK FOOTER
// ./client/components/ProgressBarPane ./~/svg-inline-loader!^\.\/.*\.svg$
// module id = 670
// module chunks = 0